import { createRouter, createWebHistory } from "vue-router";
import SignIn from "../views/SignIn.vue";
import SignUp from "../views/SignUp.vue";
// import Dashboard from "../views/Dashboard.vue";
import Cover from "../views/A&PCover.vue";
import Order from "../views/Order.vue";
import Checkout from "../views/Checkout.vue";
import ForgotPasscode from "../views/ForgotPasscode.vue";
import EnterOneTimePasscode from "../views/EnterOneTimePasscode.vue";
import ResetToInitialPasscode from "../views/ResetToInitialPasscode.vue";
import ChangePasscode from "../views/ChangePasscode.vue";
import Category from "../views/Category.vue";
import SelectPromoCode from "../views/SelectPromoCode.vue";
import PaymentSuccess from "../views/PaymentSuccess.vue";
import MyReward from "../views/MyReward.vue";
import RewardCatalogue from "../views/RewardCatalogue.vue";
import RewardDetail from "../views/RewardDetail.vue";
import MyVouchers from "../views/MyVouchers.vue";
import MyCart from "../views/MyCart.vue";
import Profile from "../views/Profile.vue";
import TopUp from "../views/TopUp.vue";
import MyTransactions from "../views/MyTransactions.vue";
import LoyaltyTierBenefit from "../views/LoyaltyTierBenefit.vue";
import GetMemberShip from "../views/GetMemberShip.vue";
import FindStores from "../views/FindStores.vue";
import VoucherBundleDetail from "../views/VoucherBundleDetail.vue";
import OrderHistory from "../views/OrderHistory.vue";
import { checkUrlExpiry, checkKioskMode } from './middleware';
import OrderLocked from "../views/OrderLocked.vue";
import Error404 from "../views/Error404.vue";
import PageExpired from "../views/PageExpired.vue";
// import ChooseNumberOfGuests from "../views/ChooseNumberOfGuests.vue";
import LandingPageKiosk from "../views/kiosk/Landing.vue";
// import CategoryPageKiosk from "../views/kiosk/Category.vue";
import OrderPageKiosk from "../views/kiosk/Order.vue";
import CheckoutPageKiosk from "../views/kiosk/Checkout.vue";
import PaymentSelectionPageKiosk from "../views/kiosk/PaymentSelection.vue";
import PaymentSuccessPageKiosk from "../views/kiosk/PaymentSuccess.vue";
import MyRewardPageKiosk from "../views/kiosk/MyReward.vue";
import PhysicalBranchOrder from "../views/PhysicalBranch/Order.vue";
import PhysicalBranch from "../views/PhysicalBranch.vue";

const routes = [
  // Physical Branch
  {
    path: "/:merchant_code/physical-branch/order",
    name: "PhysicalBranches",
    component: PhysicalBranch,
    meta: {
      requiresAuth: false,
      title: "Physical Branch - Minty Online Ordering"
    },
  },

  // MOO
  {
    path: "/:merchant_code/:type?/:branch_code/:table_code?",
    name: "Cover",
    component: Cover,
    meta: {
      requiresAuth: false,
      title: "Cover - Minty Online Ordering"
    },
    beforeEnter: checkUrlExpiry
  },
  {
    path: "/:merchant_code/:type?/:branch_code/:table_code?/order",
    name: "Order",
    component: Order,
    meta: {
      requiresAuth: false,
      title: "Order - Minty Online Ordering"
    },
    beforeEnter: checkUrlExpiry
  },
  {
    path: "/:merchant_code/:type?/:branch_code/:table_code?/queue",
    name: "Queue",
    component: Order,
    meta: {
      requiresAuth: false,
      title: "Queue - Minty Online Ordering"
    },
    beforeEnter: checkUrlExpiry
  },
  {
    path: "/:merchant_code/:type?/:branch_code/:table_code?/check-out",
    name: "CheckOut",
    component: Checkout,
    meta: {
      requiresAuth: false,
      title: "Checkout - Minty Online Ordering"
    },
    beforeEnter: checkUrlExpiry
  },
  {
    path: "/:merchant_code/:type?/:branch_code/:table_code?/sign-in/:invite_code?",
    name: "SignIn",
    component: SignIn,
    meta: {
      requiresAuth: false,
      title: "Sign In - Minty Online Ordering"
    },
    beforeEnter: checkUrlExpiry
  },
  {
    path: "/:merchant_code/:type?/:branch_code/:table_code?/sign-up",
    name: "SignUp",
    component: SignUp,
    meta: {
      requiresAuth: false,
      title: "Sign Up - Minty Online Ordering"
    },
    beforeEnter: checkUrlExpiry
  },
  {
    path: "/:merchant_code/:type?/:branch_code/:table_code?/category",
    name: "Category",
    component: Category,
    meta: {
      requiresAuth: false,
      title: "Category - Minty Online Ordering"
    },
    beforeEnter: checkUrlExpiry
  },
  {
    path: "/:merchant_code/:type?/:branch_code/:table_code?/select-promo-code",
    name: "SelectPromoCode",
    component: SelectPromoCode,
    meta: {
      requiresAuth: false,
      title: "Select Promo Code - Minty Online Ordering"
    },
    beforeEnter: checkUrlExpiry
  },
  {
    path: "/:merchant_code/:type?/:branch_code/:table_code?/payment-success/:order_id/:type_order?",
    name: "PaymentSuccess",
    component: PaymentSuccess,
    meta: {
      requiresAuth: false,
      title: "Payment Success - Minty Online Ordering"
    },
    beforeEnter: checkUrlExpiry
  },
  {
    path: "/:merchant_code/:type?/:branch_code/:table_code?/my-reward",
    name: "MyReward",
    component: MyReward,
    meta: {
      requiresAuth: false,
      title: "My Reward - Minty Online Ordering"
    },
    beforeEnter: checkUrlExpiry
  },
  {
    path: "/:merchant_code/:type?/:branch_code/:table_code?/my-vouchers",
    name: "MyVouchers",
    component: MyVouchers,
    meta: {
      requiresAuth: false,
      title: "My Vouchers - Minty Online Ordering"
    },
    beforeEnter: checkUrlExpiry
  },
  {
    path: "/:merchant_code/:type?/:branch_code/:table_code?/reward-catalogue",
    name: "RewardCatalogue",
    component: RewardCatalogue,
    meta: {
      requiresAuth: false,
      title: "Reward Catalogue - Minty Online Ordering"
    },
    beforeEnter: checkUrlExpiry
  },
  {
    path: "/:merchant_code/:type?/:branch_code/:table_code?/reward-detail/:reward_id",
    name: "RewardDetail",
    component: RewardDetail,
    meta: {
      requiresAuth: false,
      title: "Reward Detail - Minty Online Ordering"
    },
    beforeEnter: checkUrlExpiry
  },
  {
    path: "/:merchant_code/:type?/:branch_code/:table_code?/my-cart",
    name: "MyCart",
    component: MyCart,
    meta: {
      requiresAuth: false,
      title: "My Cart - Minty Online Ordering"
    },
    beforeEnter: checkUrlExpiry
  },
  {
    path: "/:merchant_code/:type?/:branch_code/:table_code?/profile",
    name: "Profile",
    component: Profile,
    meta: {
      requiresAuth: false,
      title: "Profile - Minty Online Ordering"
    },
    beforeEnter: checkUrlExpiry
  },
  {
    path: "/:merchant_code/:type?/:branch_code/:table_code?/top-up",
    name: "TopUp",
    component: TopUp,
    meta: {
      requiresAuth: false,
      title: "Top Up - Minty Online Ordering"
    },
    beforeEnter: checkUrlExpiry
  },
  {
    path: "/:merchant_code/:type?/:branch_code/:table_code?/my-transactions",
    name: "MyTransactions",
    component: MyTransactions,
    meta: {
      requiresAuth: false,
      title: "Transaction History - Minty Online Ordering"
    },
    beforeEnter: checkUrlExpiry
  },
  {
    path: "/:merchant_code/:type?/:branch_code/:table_code?/loyalty-tier-benefit",
    name: "LoyaltyTierBenefit",
    component: LoyaltyTierBenefit,
    meta: {
      requiresAuth: false,
      title: "Loyalty Tier Benefit - Minty Online Ordering"
    },
    beforeEnter: checkUrlExpiry
  },
  {
    path: "/:merchant_code/:type?/:branch_code/:table_code?/get-member-ship/:tier_id",
    name: "GetMemberShip",
    component: GetMemberShip,
    meta: {
      requiresAuth: false,
      title: "Activate Membership - Minty Online Ordering"
    },
    beforeEnter: checkUrlExpiry
  },
  {
    path: "/:merchant_code/:type?/:branch_code/:table_code?/find-branches",
    name: "FindStores",
    component: FindStores,
    meta: {
      requiresAuth: false,
      title: "Find Branches - Minty Online Ordering"
    },
    beforeEnter: checkUrlExpiry
  },
  {
    path: "/:merchant_code/:type?/:branch_code/:table_code?/voucher-bundle/:id",
    name: "VoucherBundleDetail",
    component: VoucherBundleDetail,
    meta: {
      requiresAuth: false,
      title: "Bundle Detail - Minty Online Ordering"
    },
    beforeEnter: checkUrlExpiry
  },
  {
    path: "/:merchant_code/:type?/:branch_code/:table_code?/order-history",
    name: "OrderHistory",
    component: OrderHistory,
    meta: {
      requiresAuth: false,
      title: "Order History - Minty Online Ordering"
    },
    beforeEnter: checkUrlExpiry
  },
  {
    path: "/:merchant_code/:type?/:branch_code/:table_code?/order-locked/:order_id",
    name: "OrderLocked",
    component: OrderLocked,
    meta: {
      requiresAuth: false,
      title: "Order Locked - Minty Online Ordering"
    },
    beforeEnter: checkUrlExpiry
  },
  {
    path: "/404",
    name: "Error404",
    component: Error404,
    meta: {
      title: "404 Error - Minty Online Ordering"
    }
  },
  {
    path: "/page-expired",
    name: "PageExpired",
    component: PageExpired,
    meta: {
      title: "Page Expired - Minty Online Ordering"
    }
  },
  {
    path: "/:merchant_code/:type?/:branch_code/:table_code?/completed-order-history-for-pay-first",
    name: "CompletedOrderHistoryForPayFirst",
    // Shares OrderHistory.vue with the "OrderHistory" route — the component
    // branches its fetch strategy, status labels and back button on
    // `this.$route.name === "CompletedOrderHistoryForPayFirst"`.
    component: OrderHistory,
    meta: {
      requiresAuth: false,
      title: "Completed Order History - Minty Online Ordering"
    },
    beforeEnter: checkUrlExpiry
  },
  // {
  //   path: "/:merchant_code/:type?/:branch_code/:table_code?/choose-number-of-guests",
  //   name: "ChooseNumberOfGuests",
  //   component: ChooseNumberOfGuests,
  //   meta: {
  //     requiresAuth: false
  //   },
  //   beforeEnter: checkUrlExpiry
  // },
  {
    path: "/:merchant_code/:type?/:branch_code/:table_code?/forgot-passcode",
    name: "ForgotPasscode",
    component: ForgotPasscode,
    meta: {
      requiresAuth: false,
      title: "Forgot Passcode - Minty Online Ordering"
    },
    beforeEnter: checkUrlExpiry
  },
  {
    path: "/:merchant_code/:type?/:branch_code/:table_code?/enter-one-time-passcode",
    name: "EnterOneTimePasscode",
    component: EnterOneTimePasscode,
    meta: {
      requiresAuth: false,
      title: "Enter One-Time Passcode - Minty Online Ordering"
    },
    beforeEnter: checkUrlExpiry
  },
  {
    path: "/:merchant_code/:type?/:branch_code/:table_code?/reset-to-initial-passcode",
    name: "ResetToInitialPasscode",
    component: ResetToInitialPasscode,
    meta: {
      requiresAuth: false,
      title: "Reset Passcode - Minty Online Ordering"
    },
    beforeEnter: checkUrlExpiry
  },
  {
    path: "/:merchant_code/:type?/:branch_code/:table_code?/change-passcode",
    name: "ChangePasscode",
    component: ChangePasscode,
    meta: {
      requiresAuth: false,
      title: "Change Passcode - Minty Online Ordering"
    },
    beforeEnter: checkUrlExpiry
  },

  // KIOSK
  {
    path: "/:merchant_code/:branch_code/kiosk",
    name: "LandingPageKiosk",
    component: LandingPageKiosk,
    meta: {
      requiresAuth: false,
      title: "Landing - Minty Kiosk"
    },
    beforeEnter: checkUrlExpiry
  },
  // {
  //   path: "/:merchant_code/:branch_code/kiosk/category",
  //   name: "CategoryPageKiosk",
  //   component: CategoryPageKiosk,
  //   meta: {
  //     requiresAuth: false
  //   },
  // },
  {
    path: "/:merchant_code/:branch_code/kiosk/order",
    name: "OrderPageKiosk",
    component: OrderPageKiosk,
    meta: {
      requiresAuth: false,
      title: "Order - Minty Kiosk"
    },
    beforeEnter: checkKioskMode
  },
  {
    path: "/:merchant_code/:branch_code/kiosk/checkout",
    name: "CheckoutPageKiosk",
    component: CheckoutPageKiosk,
    meta: {
      requiresAuth: false,
      title: "Checkout - Minty Kiosk"
    },
    beforeEnter: checkKioskMode
  },
  {
    path: "/:merchant_code/:branch_code/kiosk/payment-selection",
    name: "PaymentSelectionPageKiosk",
    component: PaymentSelectionPageKiosk,
    meta: {
      requiresAuth: false,
      title: "Payment Selection - Minty Kiosk"
    },
    beforeEnter: checkKioskMode
  },
  {
    path: "/:merchant_code/:branch_code/kiosk/payment-success/:transaction_id?",
    name: "PaymentSuccessPageKiosk",
    component: PaymentSuccessPageKiosk,
    meta: {
      requiresAuth: false,
      title: "Payment Success - Minty Kiosk"
    },
    beforeEnter: checkKioskMode
  },
  {
    path: "/:merchant_code/:branch_code/kiosk/my-reward",
    name: "MyRewardPageKiosk",
    component: MyRewardPageKiosk,
    meta: {
      requiresAuth: false,
      title: "My Reward - Minty Kiosk"
    },
    beforeEnter: checkKioskMode
  },
  // Physical branch
  {
    path: "/:merchant_code/physical-branch/:physical_branch_id/order",
    name: "PhysicalBranchOrder",
    component: PhysicalBranchOrder,
    meta: {
      requiresAuth: false,
      title: "Physical Branch Order"
    },
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  linkActiveClass: "active",
});

router.beforeEach((to) => {
  localStorage.setItem('MERCHANT_CODE', to.params.merchant_code ?? '')
  localStorage.setItem('BRANCH_CODE', to.params.branch_code ?? '')
  // sessionStorage (per-tab) so gotoMemberLogin can read table_code even before the
  // async route guard (checkUrlExpiry) calls next() and the route is fully resolved.
  // Only write when defined — an undefined table_code (e.g. redirect back without it
  // in the path) must not erase the value that was set on the original QR scan.
  const incomingTableCode = to.params.table_code || to.query.table_code;
  if (incomingTableCode !== undefined) {
    sessionStorage.setItem('TABLE_CODE', incomingTableCode ?? '');
  }

  // Set page title based on route meta
  if (to.meta && to.meta.title) {
    document.title = to.meta.title;
  } else {
    // Default title based on URL pattern
    if (to.path.includes('/kiosk')) {
      document.title = 'Minty Kiosk';
    } else {
      document.title = 'Minty Online Ordering';
    }
  }
})

export default router;
